import {
	GotoCleanLabelProducts,
	GotoKehe,
	GotoMinorityProducts,
	GotoNewtoMarketProducts,
	GotoNextyProducts,
	GotoPrivateProducts
} from '../Cta/Cta';
// import { SeeAll } from '../SeeAll/SeeAll';

export const LargeMobile = () => {
	return (
		<div className='newtopiaLargeMobile'>
			<div className='cardContainer'>
				<div className='topCardContainer'>
					<div className='cardPrivate'>
						<GotoPrivateProducts title='Private Label' />
					</div>
					<div className='cardLabel'>
						<GotoCleanLabelProducts title='Clean Label' />
					</div>
					<div className='cardNexty'>
						<GotoNextyProducts />
					</div>
				</div>
				<div className='midCardContainer'>
					<div className='cardNewtoMarket'>
						<GotoNewtoMarketProducts />
					</div>
				</div>
				<div className='bottomCardContainer'>
					<div className='cardMinority'>
						<GotoMinorityProducts />
					</div>
					<div className='cardKehe'>
						<GotoKehe />
					</div>
				</div>
				<div className='newtopiawave'></div>
			</div>
			<div className='footer'></div>
		</div>
	);
};
